import React from 'react';
import { GivelifyTheme } from '@givelify/givelify-ui';
import { GivelifyThemeProvider } from '@givelify/ui';
import { CssBaseline } from '@material-ui/core';
import { MuiThemeProvider } from '@material-ui/core';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export const ThemeWrapper: React.FCC = ({ children }) => (
    <>
        <CssBaseline />
        <MuiThemeProvider theme={GivelifyTheme}>
            <GivelifyThemeProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {children}
                </LocalizationProvider>
            </GivelifyThemeProvider>
        </MuiThemeProvider>
    </>
);